import { render, staticRenderFns } from "./up.vue?vue&type=template&id=dbd85424&"
import script from "./up.vue?vue&type=script&lang=js&"
export * from "./up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports